import _ from 'lodash';

class MonitoringPlanService {
    /*@ngInject*/
    constructor(catalogService, constants) {
        this.catalogService = catalogService;
        this.constants = constants;
    }

    getMonitoringPlans() {
        return this.catalogService.searchProducts(_.map(this.constants.monitoringPlans, (m) => {
                return {
                    name: 'code',
                    value: m.abbreviation
                };
            }))
            .then((result) => {
                return result.data.products;
            });
    }

    isMonitoringPlan(product) {
        return _.some(this.constants.monitoringPlans, (m) => {
            return _.toLower(m.abbreviation) === _.toLower(product.sku);
        });
    }

    getMonthlyPrice(product) {
        return _.find(product.properties, { displayName: 'monthly_price' }).value;
    }
}

export default MonitoringPlanService;